export const carouselData = [
    {
        id: 0,
        image : "assets/images/msd.jpg",
        caption: "The performance is not guaranteed, the effort is.",
        author: "M.S. Dhoni"
    },
    {
        id: 1,
        image : "assets/images/barack.jpg",
        caption: "When times get tough, we don't give up, we get up.",
        author: "Barack Obama"
    },
    {
        id: 2,
        image : "assets/images/apj.jpg",
        caption: "You have to dream before your dreams can come true.",
        author: "Dr. A.P.J. Abdul Kalam"
    }

]